import { render, staticRenderFns } from "./PageHeaderCom.vue?vue&type=template&id=1fdf633d&scoped=true"
import script from "./PageHeaderCom.vue?vue&type=script&lang=js"
export * from "./PageHeaderCom.vue?vue&type=script&lang=js"
import style0 from "./PageHeaderCom.vue?vue&type=style&index=0&id=1fdf633d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdf633d",
  null
  
)

export default component.exports